var exports = {
  "kL": "xe7b6e3d6--90e7b5--container",
  "Kk": "xe7b6e3d6--90e7b5--icon",
  "Pf": "xe7b6e3d6--90e7b5--label",
};

module.exports = exports;
